
import Layout from '../../../layouts/main'
import { useState } from 'react';
import { toast } from 'react-toastify';
import config from '../../../../configuration/config.json'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import cbor from 'borc';
import { Buffer } from 'buffer';
import { useEffect } from 'react';


export default () => {
    const navigate = useNavigate();
    const [getdocuments, setdocuments] = useState([]);
    const [getSelectedDocId, setSelectedDocId] = useState('0');
    const [getTemplateMode, setTemplateMode] = useState('Exist');
    const [getSaveMode, setSaveMode] = useState('');
    const [getTemplateHeaders, setTemplateHeaders] = useState([]);
    const [getSelectedTemplateId, setSelectedTemplateId] = useState('0');
    const [getSelectedDocumentData, setSelectedDocumentData] = useState([]);


    const loadDataOnlyOnce = async () => {
        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl +'document/configurations/schemas',
            headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'arraybuffer',
            responseEncoding: 'binary'
        });

        if (response.status == 200) {
            let documentSchemasDecoded = cbor.decode(new Buffer(response.data));
            setdocuments(documentSchemasDecoded);
            
        } else {
            setdocuments([]);
        }

    }

    const loadTemplateHeaders = async () => {
        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl +'document/configurations/templates/headers',
            headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'arraybuffer',
            responseEncoding: 'binary'
        });

        if (response.status == 200) {
            let templateHeadersDecoded = cbor.decode(new Buffer(response.data));
            
            setTemplateHeaders(templateHeadersDecoded);
        } else {
            setTemplateHeaders([]);
        }

    }

    useEffect(() => {
        loadDataOnlyOnce();
        loadTemplateHeaders();
    }, [])

    return (
        <Layout>

            <div class="container-fluid mt-5">
                <div class='row'>
                    <h class='header1'>Templates</h>
                </div>
                <div class="row">
                    <div class="col-md-6  mt-3">
                        {
                            (getTemplateMode == 'Exist') ?
                                <select class="textField" onChange={populateSelectedTemplateDetails} id='ddlTemplates'>
                                    <option value='0'>Select Template</option>
                                    {
                                        getTemplateHeaders.map(header => (
                                            <option value={header._id}>{header.friendlyName}</option>
                                        ))
                                    }
                                </select>
                                :
                                <input type="text" id='tbTemplateName' class="textField" placeholder="New Template Name" />
                        }

                    </div>
                    <div class="col-md-6">

                        {
                            (getTemplateMode == 'New') ?
                                <select class="textField mt-3 w-50" onChange={ApplySelectedDocId} id='dlDocuments'>
                                    <option value='0'>Select Docment</option>
                                    {
                                        getdocuments.map(doc => (
                                            <option value={doc._id}>{doc.friendlyName}</option>
                                        ))
                                    }
                                </select>
                                :
                                ''
                        }


                        {

                            (getSaveMode != 'Save' && getTemplateMode == 'Exist') ?
                                <button type="button" class="primaryButton mt-4  ms-1" onClick={NewTemplateMode} aria-label="submit">New Template</button>
                                : ''


                        }

                        {

                            (getSaveMode == 'Save' || getTemplateMode == 'New') ?
                                <button type="button" class="secondaryButton mt-4 ms-1" onClick={CancelTemplateMode} aria-label="submit">Cancel</button> : ''

                        }

                        {

                            (getSaveMode == 'Save') ?
                                <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">Submit</button>
                                : ''

                        }



                    </div>
                </div>

                <div class='row'>
                    <div className='col'>
                        <div key={Math.random()}>

                            {
                                getSelectedDocumentData?.map(ds =>
                                (
                                    <>
                                        <div class='row'>
                                            <div class="col mt-3 docTypeHeader ">
                                                <label>Doc Type:&nbsp;</label>
                                                <label class='textTransformNone'>{ds.documentData.docType}</label>

                                            </div>
                                        </div>

                                        {

                                            ds.documentData.namespaces?.map(nm => (

                                                <div class='row'>
                                                    <div class="col mt-3">
                                                        <div class='row'>
                                                            <div class='col header2'>
                                                                <label>Namespace:&nbsp;</label>
                                                                <label class='textTransformNone'>{nm.name}</label>
                                                            </div>
                                                        </div>
                                                        <div class='row'>
                                                            {nm.labels?.map(lb =>

                                                            (
                                                                <div class='col-4'>

                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            <div class='row'>
                                                                                <div class='col-md-7'>
                                                                                    <label class='form-text'>
                                                                                        {lb.local_language_name == undefined || lb.local_language_name == '' ? lb.name
                                                                                            : lb.name + ' / ' + lb.local_language_name
                                                                                        }
                                                                                    </label>
                                                                                </div>

                                                                                <div class='col-md-3'>
                                                                                    {(lb.name.toUpperCase() == 'driving_privileges'.toUpperCase() ||
                                                                                        lb.name.toUpperCase() == 'objectIssuerJson'.toUpperCase() ||
                                                                                        lb.name.toUpperCase() == 'sex'.toUpperCase()
                                                                                    ) ?
                                                                                        <select class='textField' onChange={showCborTextBox} id={'type_' + getSelectedDocId + '_' + nm.name + '_' + lb.name}>
                                                                                            <option value='custom' selected={lb.control_type == 'custom'}>custom</option>
                                                                                        </select>

                                                                                        :

                                                                                        <select class='textField' onChange={showCborTextBox} id={'type_' + getSelectedDocId + '_' + nm.name + '_' + lb.name}>
                                                                                            <option value='text' selected={lb.control_type == 'text'}>text</option>
                                                                                            <option value='date' selected={lb.control_type == 'date'} >date</option>
                                                                                            <option value='photo' selected={lb.control_type == 'photo'}>photo</option>
                                                                                            <option value='number' selected={lb.control_type == 'number'}>number</option>
                                                                                            <option value='boolean' selected={lb.control_type == 'boolean'}>boolean</option>
                                                                                            <option value='custom' selected={lb.control_type == 'custom'}>custom</option>
                                                                                        </select>

                                                                                    }
                                                                                </div>

                                                                                <div class='col-md-2'>
                                                                                    <div class="form-check form-switch">
                                                                                        <input class="form-check-input" type="checkbox" id={'e_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} name={'e_' + getSelectedDocId + '_' + nm.name + '_' + lb.name}
                                                                                            defaultChecked={lb.enrollment_flag == undefined || lb.enrollment_flag == false ? '' : 'checked'}
                                                                                            value="yes" />
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            <input type="text" id={getSelectedDocId + '_' + nm.name + '_' + lb.name} defaultValue={lb.default_value} placeholder='Default Value' 
                                                                            disabled={lb.name.toUpperCase() == 'SEX' || lb.control_type == 'photo' || lb.control_type == 'date' || 
                                                                            lb.name.toUpperCase() == 'driving_privileges'.toUpperCase()} 
                                                                            class="textField formText" aria-label={lb.name} />
                                                                            <input type="number" id={'cbor_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} defaultValue={lb.cbor_tag} placeholder='CBOR Tag Value' class="textField formText mt-2" style={{ display: lb.control_type == 'date' ? 'block' : 'none' }} aria-label={lb.cbor_tag} />
                                                                        </div>
                                                                    </div>



                                                                </div>
                                                            )
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>

                                            ))

                                        }

                                    </>

                                ))

                            }

                        </div>
                    </div>
                    <div class='row'>
                        <div class='col'>

                            {

                                (getSaveMode == 'Save') ?
                                    <button type="button" class="secondaryButton mt-4" onClick={CancelTemplateMode} aria-label="submit">Cancel</button> : ''

                            }

                            {

                                (getSaveMode == 'Save') ?
                                    <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">Submit</button>
                                    : ''

                            }
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    );

    function ApplySelectedDocId() {
        let selectedDocumentId = document.getElementById('dlDocuments').value;
        setSelectedDocId(selectedDocumentId);
        setSaveMode(document.getElementById('dlDocuments').value == '0' ? '' : 'Save');
        
        let selectedDocument = getdocuments.filter(selected => selected._id == selectedDocumentId);
        setSelectedDocumentData([]);
        setSelectedDocumentData(selectedDocument);
    }

    function NewTemplateMode() {
        document.getElementById('ddlTemplates').value = '0';
        setSelectedDocumentData([]);
        setTemplateMode('New');
        setSaveMode('');
    }


    function CancelTemplateMode() {
        
        setSelectedDocumentData([]);
        setTemplateMode('Exist');
        setSaveMode('');
        if(document.getElementById('ddlTemplates') != null){
            document.getElementById('ddlTemplates').value = '0';
        }
        setSelectedDocId('0')
        setSelectedTemplateId('0')
    }

    async function postconfigurations() {

        document.getElementById('loadingProgressG').style.display = 'block';
        let validationPassed = true;

        try {
            let documentTemplate = {
                documentData: {
                    docType: getSelectedDocumentData[0].documentData.docType,
                    namespaces: []
                },
                documentId: getTemplateMode == 'New' ? getSelectedDocumentData[0]._id :
                    getSelectedDocumentData[0]._documentId,
                friendlyName: getTemplateMode == 'New' ?
                    document.getElementById('tbTemplateName').value : getSelectedDocumentData[0].friendlyName,
              

            }
            
        if(getTemplateMode == 'Exist'){
            documentTemplate._id = getSelectedDocumentData[0]._id 
        }

            if (getTemplateMode == 'New' && document.getElementById('tbTemplateName').value.length == 0) {
                toast.error('Please enter the new template name.');
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }


            getSelectedDocumentData?.map(ds => {

                ds.documentData.namespaces?.map(nm => {

                    let namespace = {
                        name: nm.name,
                        labels: []
                    }

                    nm.labels?.map(lb => {

                        let label = {
                            name: lb.name,
                            default_value: document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value,
                            enrollment_flag: document.getElementById('e_' + getSelectedDocId + '_' + nm.name + '_' + lb.name).checked,
                            control_type: document.getElementById('type_' + getSelectedDocId + '_' + nm.name + '_' + lb.name).value,

                        }

                        if (label.control_type == 'date') {
                            label.cbor_tag =
                                document.getElementById('cbor_' + getSelectedDocId + '_' + nm.name + '_' + lb.name).value;

                            if (label.cbor_tag == undefined || label.cbor_tag.length == 0) {
                                validationPassed = false;
                                toast.error('Please enter the Cbor tag value for ' + lb.name);
                                return;
                            }

                        }

                        if (label.name.toUpperCase() == 'objectDataJSON'.toUpperCase()) {

                            if ((label.default_value == undefined || label.default_value.length == 0)
                                || (label.enrollment_flag == false)) {
                                validationPassed = false;
                                toast.error('Please enable and enter the value for ' + lb.name);
                                return;
                            }

                        }

                        if (label.name.toUpperCase() == 'objectIssuerJson'.toUpperCase()) {

                            if ((label.default_value == undefined || label.default_value.length == 0)
                                || (label.enrollment_flag == false)
                            ) {
                                validationPassed = false;
                                toast.error('Please enable and enter the value for ' + lb.name);
                                return;
                            }

                        }

                        namespace.labels.push(label);
                    });

                    documentTemplate.documentData.namespaces.push(namespace);
                });

            });
            

            if (validationPassed) {
                const response = await axios.request({
                    method: 'POST',
                    url: config.operatorportal.apibaseurl +'document/configurations/templates',
                    headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
                    responseType: 'arraybuffer',
                    responseEncoding: 'binary',
                    data: cbor.encode(documentTemplate)
                });

                
                if (response.status == 200) {
                    toast.success('Post request Succeded.');
                    loadTemplateHeaders();
                    CancelTemplateMode();
                } else {
                    toast.error('Failed.');
                }

            }


            document.getElementById('loadingProgressG').style.display = 'none';

        } catch (error) {
            document.getElementById('loadingProgressG').style.display = 'none';
            toast.error(error.message)
        }



    }


    async function populateSelectedTemplateDetails() {

        try {

            document.getElementById('loadingProgressG').style.display = 'block';
            let selectedTemplateId =
                document.getElementById('ddlTemplates').value;
            setSelectedTemplateId(selectedTemplateId);

            if (selectedTemplateId == '0') {
                setdocuments([]);
                CancelTemplateMode();
                return;
            }



            const response = await axios.request({
                method: 'GET',
                url: config.operatorportal.apibaseurl +'document/configurations/templates?id=' + selectedTemplateId,
                headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
            });


            if (response.status == 200) {
                let templateDecoded = cbor.decode(new Buffer(response.data));
                setSelectedDocumentData([]);
                let selectedDoc = [];
                selectedDoc.push(templateDecoded)
                setSelectedDocumentData(selectedDoc);
                setSaveMode('Save');
                toast.success('GET request Succeded.');
                
            } else {
                setSelectedDocumentData([]);
                toast.error('Failed.');
            }

            document.getElementById('loadingProgressG').style.display = 'none';

        } catch (error) {
            document.getElementById('loadingProgressG').style.display = 'none';
            toast.error(error.message);
        }




    }


    function showCborTextBox(e) {

        if (e.target?.id != undefined) {

            if (e.target.value == 'date') {
                document.getElementById(e.target.id.replace('type_', 'cbor_')).style.display = 'block';
            } else {
                document.getElementById(e.target.id.replace('type_', 'cbor_')).value = '';
                document.getElementById(e.target.id.replace('type_', 'cbor_')).style.display = 'none';
            }

        }

    }

}


